// on the plp, store the url. separate script runs on the pdp to check local storage

const isBlogs = window.location.href.includes('blogs')
const isProduct = window.location.href.includes('products')
const isPages = window.location.href.includes('pages')
const urlTemplate = isBlogs ? 'blogs' : isPages ? 'pages' : 'collections'

if (window.location.href.includes(urlTemplate)) {
  let relativeUrl = window.location.href.split(`${urlTemplate}`)[1]

  if (isBlogs) {
    const articleParts = relativeUrl.split('/')
    if (articleParts.length > 2) {
      relativeUrl = `/${articleParts[2]}`
    }
  }

  relativeUrl = relativeUrl.split('?')[0]

  if (!isProduct) {
    localStorage.setItem('prevPage', `/${urlTemplate}${relativeUrl}`)
  }
}
